import { FigureShopify } from '@studiometa/ui';

/**
 * Figure component with eager loading via rootMargin.
 */
export default class Figure extends FigureShopify {
  static config = {
    ...FigureShopify.config,
    name: 'Figure',
    options: {
      ...FigureShopify.config.options,
      intersectionObserver: {
        type: Object,
        default: () => ({ rootMargin: '50%' }),
      },
    },
  };
}
